import {
    FETCH_ACCOUNT,
    FETCH_ACCOUNTS,
    FETCH_ACCOUNTS_ACCUMULATED,
    FETCH_ACCOUNTS_FAILURE,
    FETCH_ACCOUNTS_SUCCESS,
    FETCH_ACCOUNT_ACCUMULATED,
    FETCH_ACCOUNT_FAILURE,
    FETCH_ACCOUNT_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchAccounts = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'name',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (payload.name) {
        params.name = payload.name;
    }

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_ACCOUNTS,
        payload: params,
    };
};

export const fetchAccountsFailure = (error) => {
    return {
        type: FETCH_ACCOUNTS_FAILURE,
        payload: error,
    };
};

export const fetchAccountsSuccess = (payload) => {
    return {
        type: FETCH_ACCOUNTS_SUCCESS,
        payload: payload,
    };
};

export const fetchAccount = (payload) => {
    return {
        type: FETCH_ACCOUNT,
        payload: payload,
    };
};

export const fetchAccountFailure = (error) => {
    return {
        type: FETCH_ACCOUNT_FAILURE,
        payload: error,
    };
};

export const fetchAccountSuccess = (response) => {
    return {
        type: FETCH_ACCOUNT_SUCCESS,
        payload: response,
    };
};

export const fetchAccountAccumulated = (payload) => {
    return {
        type: FETCH_ACCOUNT_ACCUMULATED,
        payload: {
            id: payload.id,
            resource: 'accounts',
            type: FETCH_ACCOUNTS_ACCUMULATED,
        },
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accounts/fetchAccounts.js